class PickupPointsMap {
  constructor({ element, points }) {
    this.element = element;
    this.points = points;
    // this.active
    this.offices = [];
    this.map = null;
    this.center = [0, 0];
    this.zoom = 17;
    this.currentValue = null;

    this.initObject();
    this.createMap();
    this.eventListeners();
    this.mapFilter();
  }

  eventListeners() {
    document.addEventListener('pickupPoint:point:changed', (e) => {
      this.currentValue = e.detail.value;
      this.centerPickPoint();
    });

    document.addEventListener('pickupPoint:map:destroy', () => {
      this.map.destroy();
    })
  }

  centerPickPoint() {
    const office = this.offices.find((office) => office.id === this.currentValue);
    this.map.setCenter([office.lat, office.lng], office.zoom, {duration: 500});
  }

  initObject() {
    this.points.forEach((point) => {
      const placemark = this.createPlacemark({
        id: point.id,
        lat: point.addressLat,
        lng: point.addressLng
      });

      this.offices.push({
        id: point.id,
        placemark,
        lat: point.addressLat,
        lng: point.addressLng,
        zoom: point.addressZoom
      });
    });
  }

  createMap() {
    this.element = document.querySelector('[data-cart-map]');

    this.map = new ymaps.Map(this.element, {
      center: this.center,
      zoom: this.zoom,
      controls: ['zoomControl'],
    }, {
      zoomControlSize: 'small',
    });
    this.map.behaviors.disable('scrollZoom');

    this.map.margin.setDefaultMargin([31, 31, 31, 31]);

    this.map.geoObjects.events.add('click', function (e) {
      var target = e.get('target');
      document.dispatchEvent(
          new CustomEvent("pickupPoint:map:placemark:click", {
            detail: {
              id: target.properties._data.id
            }
          })
      )
    });

    this.fitCenter();

    this.offices.map((office) => {
      this.map.geoObjects.add(office.placemark);
    });
  }

  getCenterCoordsByAllVisibleOffices() {
    // Берем все координаты от всех точек
    let minLat;
    let minLng;
    let maxLat;
    let maxLng;

    this.offices.forEach((office) => {
      if (minLat === undefined || office.lat) {
        minLat = office.lat;
      }
      if (maxLat === undefined || maxLat < office.lat) {
        maxLat = office.lat;
      }

      if (minLng === undefined || minLng > office.lng) {
        minLng = office.lng;
      }
      if (maxLng === undefined || maxLng < office.lng) {
        maxLng = office.lng;
      }
    });

    return [[minLat, minLng], [maxLat, maxLng]];
  }

  fitCenter() {
    const coords = this.getCenterCoordsByAllVisibleOffices();
    // Определяем центр и оптимальный зум
    ymaps.util.requireCenterAndZoom(
        this.map.getType(),
        coords,
        this.map.container.getSize(),
        { margin: [31, 31, 31, 31] },
    ).then((result) => {
      this.map.setCenter(result.center, result.zoom, {duration: 500});
    });
  }

  createPlacemark({id, lat, lng}) {
    return new ymaps.Placemark([lat, lng], {id: id}, {
      // Опции.
      // Необходимо указать данный тип макета.
      iconLayout: 'default#image',
      // Своё изображение иконки метки.
      iconImageHref: '/static/images/svg/placemark.svg',
      // Размеры метки.
      iconImageSize: [26, 26],
      // Смещение левого верхнего угла иконки относительно
      // её "ножки" (точки привязки).
      iconImageOffset: [-17, -40],
    });
  }

  mapFilter() {
    const version = this.getVersion();
    const groundPaneClass = `ymaps-${version}-ground-pane`;
    const groundPane = document.querySelector(`.${groundPaneClass}`);

    // const copyrightClass = `ymaps-${version}-map-copyrights-promo`;
    // const copyRight = document.querySelector(`.${copyrightClass}`);
    //
    // if (copyRight) {
    //   copyRight.style.display = 'none';
    // }

    if (groundPane) {
      groundPane.firstChild.style.filter = 'grayscale(100%)';
    }

  }

  getVersion() {
    return ymaps.meta.version.replace(/\./g, '-')
  }
}

document.addEventListener('pickupPoint:map:init', (e) => {
  new PickupPointsMap(e.detail);
})